/** Display money consistently in the catalogue, order screens and outgoing email. */
export function shopCurrencyDigits(currency) {
    return new Intl.NumberFormat("en", { style: "currency", currency }).resolvedOptions().maximumFractionDigits ?? 2;
}
export function shopCurrencySymbol(currency, language = "en") {
    return new Intl.NumberFormat(language, { style: "currency", currency, currencyDisplay: "narrowSymbol" }).formatToParts(0).find(p => p.type === "currency")?.value ?? currency;
}
export function formatShopMoney(amount, currency, language = "en") {
    const parts = new Intl.NumberFormat(language, { style: "currency", currency, currencyDisplay: "narrowSymbol" }).formatToParts(amount / 10 ** shopCurrencyDigits(currency));
    return parts.map((part, index) => part.type === "currency" && /^[A-Za-z]+$/.test(part.value) && parts[index + 1]?.type === "integer" ? `${part.value}\u00a0` : part.value).join("");
}
